import { Box, Typography } from "@mui/material";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import type { Bank } from "Infrastructure/Api/Api";
import { Trans } from "react-i18next";
import {
  Resources,
  useResource,
  getResourcePath,
} from "Translations/Resources";

type Props = {
  bank: Bank;
};

export const Warning = ({ bank }: Props) => {
  const { t } = useResource();

  return (
    <Box>
      <Typography
        component="h2"
        variant="body1"
        color="error"
        fontWeight="bold"
      >
        {t(Resources.BankRating.Detail.Titles.Warning)}
      </Typography>
      <ErrorText>
        <Trans
          i18nKey={getResourcePath(Resources.BankRating.Banks[bank].Warnings)}
          components={{ linebreak: <br /> }}
        />
      </ErrorText>
    </Box>
  );
};
